import * as BABYLON from 'babylonjs';
import Node from '../node.js';
import Spline from '../spline.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';

const PROJ_NORMALS = {
	'zy': new BABYLON.Vector3(1, 0, 0),
	'xy': new BABYLON.Vector3(0, 0, 1),
	'xz': new BABYLON.Vector3(0, 1, 0),
};

export default class NodeConvertCurve extends Node
{
	static CONVERT_CHOICES =
	[
		{key: 'to2D', label: 'To 2D'},
		{key: 'to3D', label: 'To 3D'},
	]

	static PLANE_CHOICES =
	[
		{key: 'useNormal', label: 'Use Curve Plane Normal'},
		{key: 'zy', label: 'Z-Y'},
		{key: 'xy', label: 'X-Y'},
		{key: 'xz', label: 'X-Z'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.SPLINE, 'spline', null);
		this.addInput(PARAM_TYPE.DROPDOWN, 'target_space', NodeConvertCurve.CONVERT_CHOICES[1].key, { dropdownOptions: NodeConvertCurve.CONVERT_CHOICES });

		this.addInput(PARAM_TYPE.DROPDOWN, 'projection_plane', NodeConvertCurve.PLANE_CHOICES[3].key, { dropdownOptions: NodeConvertCurve.PLANE_CHOICES });

		this.addInput(PARAM_TYPE.FLOAT, 'move_x', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'move_y', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'move_z', 0.0, { minValue: -3, maxValue: 3, units: PARAM_UNITS.METERS });

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}

	getType()
	{ 
		return 'convertCurve';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		if(strInputName === 'projection_plane')			
			return this.getLastInputResult('target_space') == 'to2D';
		return true;
	}

	getRefreshEnableStatusAfterParamChange(strInputName)
	{
		return strInputName == 'target_space';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pSpline = new Spline(inputValues['spline'])

		let projNormal = new BABYLON.Vector3(0, 1, 0);
		if(inputValues['target_space'] === 'to2D')
		{
			if(inputValues['projection_plane'] != 'useNormal')
				projNormal = PROJ_NORMALS[inputValues['projection_plane']];
			else
				projNormal = pSpline.getNormal();
			pSpline.projectOntoPlane(projNormal);
		}
		else
			pSpline.unprojectOntoPlane(projNormal);

		if(pSpline.getIs3D())
			pSpline.translate3D(inputValues['move_x'], inputValues['move_y'], inputValues['move_z']);
		else
			pSpline.translate(inputValues['move_x'], inputValues['move_z']);

		return pSpline.saveToObject();
	}
}